<template>
  <j-modal
    :title="title"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
        <a-button key="close" @click="handleCancel">
          {{ $t('关闭') }}
        </a-button>
    </template>
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls(taskName)">{{ $t('导出') }}</a-button>
      <span class="float-right" style="float: right">
        <a>{{ $t('导入总条数:') }} {{model.recordNum}}</a>
        <a style="padding-left: 5px">{{ $t('成功条数:') }} {{model.recordSuccNum}}</a>
      </span>
    </div>
    <a-table ref="table" size="middle" bordered  :columns="columns" :dataSource="dataSource"
      :loading="loading"
      class="j-table-force-nowrap"
      @change="handleTableChange">
    </a-table>
  </j-modal>
</template>
<script>
  import {getAction,downFile,getFileAccessHttpUrl,postAction} from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { isNull } from '@/utils/validate'

  export default {
    name: "showBatchSignUpModal",
    mixins: [JeecgListMixin],
    components: {
    },
    data() {
      return {
        description: '模组管理管理页面',
        model: {},
        confirmLoading: false,
        visible: false,
        disableMixinCreated: true,
        url: {
          // list: '/model/infraredModel/queryCurrentModelList',
          // exportXlsUrl: "/model/infraredModel/exportTaskXls",
        },
        taskName: ''
      }
    },
    computed: {
      // i18n：标题/表格列使用 computed 以响应语言切换
      title () {
        return this.$t('操作')
      },
      columns () {
        return [{
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: (t, r, index) => {
              return parseInt(index) + 1;
            }
          },
          {
            title: this.$t('模组号'),
            align: "center",
            dataIndex: 'modelCode'
          },
          {
            title: this.$t('信息'),
            align: "center",
            dataIndex: 'remark'
          }
        ]
      },
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      edit(record) {
        if(isNull(record.recordNum)) {
          record.recordNum = 0;
        }
        if(isNull(record.recordSuccNum)) {
          record.recordSuccNum = 0
        }
        this.model = record;
        this.visible = true;
        this.taskName = record.taskName;
        this.queryParam.taskId = record.id;
        this.loadData(1);
      },
      loadData(arg) {
        //加载数据 若传入参数1则加载第一页的内容
        var params = this.queryParam;//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
    }
  }
  </script>